import React from 'react';
import './CaseStudyListingHeader.css';

const CaseStudyListingHeader = () => {
  return (
    <header className="case-study-listing-header">
      <h1 className="case-study-header-title">
        Branchenlösungen im Überblick
      </h1>
      <p className="case-study-header-subtitle">
        Hier findet ihr unsere speziell entwickelten Branchenlösungen KMUs.
        Jedes Projekt zeigt, wie durchdachte digitale Strategien zu effizienteren Abläufen, mehr Sichtbarkeit und nachhaltigem Wachstum führen können.
      </p>
    </header>
  );
};

export default CaseStudyListingHeader;
